import { Component, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  getUIPathCurrentConnector,
  getIsLoadingDetail
} from '../store/selectors/rpa-uipath-conn.selector';
import { Observable } from 'rxjs';
import { UpdateUIPathConn, TestUIPathConn } from '../store/actions/rpa-uipath-conn.actions';
import { BotConfigurationComponent } from 'app/rpa-bots/shared/bot-configuration/bot-configuration.component';
import { UipathConfigurationComponent } from 'app/rpa-bots/uipath/uipath-configuration/uipath-configuration.component';
import { RpaConnectorDetail } from 'app/rpa-bots/core/rpa-details-details.types';
import { RpaBotsService } from '../../core/rpa-bots.service';
import { IAppState } from '../../../../app/IAppState';
import { IRPAWrapperDetails, IRpaConnectionUiPath } from 'app/rpa-bots/core/IRpaBots';

@Component({
  selector: 'uipath-detail-wrapper',
  templateUrl: 'uipath-detail-wrapper.component.html',
  styleUrls: ['uipath-detail-wrapper.component.scss']
})
export class UiPathDetailWrapperComponent
implements OnInit, IRPAWrapperDetails {

  public uiPathConnection$: Observable<IRpaConnectionUiPath>;
  private uiPathOriginalConnection: IRpaConnectionUiPath = null;
  public isLoading$: Observable<boolean>;
  @ViewChild('botConfiguration', { static: false})

  private _uipathConfigurationComponent: UipathConfigurationComponent;
  private _botConfigurationComponent: BotConfigurationComponent;
  public enableClientCredOnPremiseUipath = false;

  constructor(private _store: Store<IAppState>,
    private _rpaBotsService: RpaBotsService) {
    this.uiPathConnection$ = this._store.pipe(
      select(getUIPathCurrentConnector)
    );

    this.uiPathConnection$.subscribe(uiPathConnection => {
      if(!this.uiPathOriginalConnection && uiPathConnection){
        this.uiPathOriginalConnection = {...uiPathConnection};
      }
    });


    this.isLoading$ = this._store.pipe(select(getIsLoadingDetail));
  }

  ngOnInit() { 
    this._rpaBotsService.getKeys().subscribe(keys => {
      this.enableClientCredOnPremiseUipath = keys['enableClientCredOnPremiseUipath'];
    });
  }

  onTestConnection(uiPathConnection: IRpaConnectionUiPath) {
    this._store.dispatch(new TestUIPathConn(uiPathConnection));
  }

  onSave(bot: IRpaConnectionUiPath) {
    this._store.dispatch(new UpdateUIPathConn(bot));
    this.uiPathOriginalConnection = Object.assign({}, bot);
  }

  get isConnectorValid(): boolean {
    return this._uipathConfigurationComponent ? this._uipathConfigurationComponent.isValid() : false;
  }

  get hasPendingChanges(): boolean {
    return this._uipathConfigurationComponent ? this._uipathConfigurationComponent.hasChanges : false;
  }

  get modifiedConnector(): RpaConnectorDetail {
    return this._uipathConfigurationComponent ? this._uipathConfigurationComponent.botDetail : null;
  }
}

